
import angular from 'angular';

const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['object', '$uibModalInstance'],
    required: []
};

export class GenericModalAncillariesController implements ng.IController {
    public tooltipOpened = false;
    public tooltipComponent = null;
    public model;
    public totalFormatted;
    public deleteBaggage;
    public addBaggage;
    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService) {
        this.model = object;
    }
    accept = (): void => {
        this.$uibModalInstance.close();
    };


    close = (): void => {
        this.$uibModalInstance.dismiss();
    };

}


try {
    GenericModalAncillariesController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(GenericModalAncillariesController.name, GenericModalAncillariesController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    GenericModalAncillariesController.$inject = controllerInfo.inject;
    mod.controller(GenericModalAncillariesController.name, GenericModalAncillariesController);
}